import React from 'react';
import { LastOrderedMessageDate } from './last-ordered-message-date';
import { ParLevel } from './par-level';
import { StyleSheet, View } from 'react-native';

interface Props {
  isLastOrderedMessageVisible: boolean;
  isParLevelsVisible: boolean;
  orderGuidePartitionUUID?: string;
  variantPackUUID: string;
}

export const OrderGuideInfo: React.FC<Props> = ({
  isLastOrderedMessageVisible,
  isParLevelsVisible,
  orderGuidePartitionUUID,
  variantPackUUID,
}) => {
  return (
    <View style={styles.base}>
      <View style={styles.item}>
        {isLastOrderedMessageVisible ? (
          <LastOrderedMessageDate variantPackUUID={variantPackUUID} />
        ) : null}
      </View>
      <View style={[styles.item, styles.rightItem]}>
        {isParLevelsVisible ? (
          <ParLevel
            orderGuidePartitionUUID={orderGuidePartitionUUID}
            variantPackUUID={variantPackUUID}
          />
        ) : null}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  base: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 4,
    paddingHorizontal: 2,
  },
  item: {
    flex: 1,
  },
  rightItem: {
    alignItems: 'flex-end',
  },
});
